import React, {useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../../components/modal/WizModal'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import {deleteRecommendApi} from '../../../../apis/recommend/deleteRecommendApi'

interface IProps {
    className?: string
}

const DeleteRecommendModal = ({className}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [postId, setPostId] = useState('')

    useImperativeHandle(ref, () => ({
        show: postId => {
            setPostId(postId)
            modalRef.current.show()
        },
    }))

    const onClickDelete = async () => {
        await deleteRecommendApi(postId).then(() => {
            alert('Remove Recommend Post')
            modalRef.current.close()
        })
    }

    return (
        <>
            <WizModal title={'Remove Recommend'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>해당 추천 포스트를 정말 내리시겠습니까? </Text>

                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton text={'Remove'} type={'red'} className={'flex-1'} onClick={() => onClickDelete()} />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(DeleteRecommendModal)
